const connectWhen = (condition, connect) => (node) => (condition ? connect(node) : node);

export default connectWhen;
